export default ({ formData, schema, uiSchema }) => {
  let newFormData = null;
  if (Array.isArray(formData) && formData.length === 1) {
    newFormData = formData[0];
  }
  return { schema, uiSchema, formData: newFormData };
};



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/toRadio/fromCheckboxes.js